// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-body[data-v-77a90586]{height:100vh;background-color:var(--lms-tenant)}@media screen and (min-height:750px){.my-body[data-v-77a90586]{height:90vh}}div[data-v-77a90586]{color:#fff!important}", ""]);
// Exports
module.exports = exports;
